import { render, staticRenderFns } from "./PppoeplusGlobalConfig.vue?vue&type=template&id=7b39d8c8&"
import script from "./PppoeplusGlobalConfig.vue?vue&type=script&lang=js&"
export * from "./PppoeplusGlobalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports